import DarkRadial from "@/assets/svg/vvv/dark-radial.svg";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Link } from "react-router-dom";
import VVVPrimaryButton from "../design-system/vvv/Button";

export default function ForCreators() {
  const { ref, isVisible } = useScrollReveal();

  const left = [
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/life-with-coco.jpg",
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/minamichigasaki.jpg",
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/tetu.jpg",
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/haribptXploring.jpg",
  ];

  const right = [
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/brien-foerster.jpg",
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/nicole-burch.jpg",
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/freaktography.jpg",
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/the-impossible-build.jpg",
  ];

  return (
    <div
      ref={ref}
      className="p-6 md:p-12 h-[700px] lg:h-[650px] xl:h-[750px] 4xl:h-[800px] relative overflow-hidden 4xl:max-w-[100rem] 4xl:mx-auto"
    >
      <div className="flex flex-col items-center justify-center text-center gap-6">
        <div
          className={`space-y-2 transition-all duration-300 ${
            isVisible ? "zoom-in" : "opacity-0 scale-90"
          }`}
        >
          <p className="text-white/50">For Content Owners</p>

          <h1
            className="vvv-font text-4xl md:text-5xl max-w-4xl"
            style={{ lineHeight: 1.2 }}
          >
            Get the <span className="text-primary">most revenue</span> possible
            from every video <span className="text-primary">you create</span>
          </h1>
        </div>

        <p
          className={`text-white max-w-xs md:max-w-full ${
            isVisible ? "zoom-in-delay" : "opacity-0 scale-90"
          }`}
        >
          VVV is the single best way to promote your video clip
        </p>

        <Link
          to="/submit-clips"
          className={isVisible ? "zoom-in-late" : "opacity-0 scale-90"}
        >
          <VVVPrimaryButton name="Submit your clip" />
        </Link>
      </div>

      <div className="video-container-creators absolute left-1/2 -translate-x-1/2 bottom-14 md:bottom-[90px] lg:bottom-14">
        <div className={isVisible ? "zoom-in" : "opacity-0 scale-90"}>
          <video
            preload="metadata"
            loading="lazy"
            autoPlay
            muted
            loop
            playsInline
            className="video"
          >
            <source
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/ski.mp4"
              type="video/mp4"
            />
          </video>
          <div className="absolute inset-0 bg-[#1B25F2]/10"></div>
        </div>
      </div>

      <div
        className={`flex flex-col lg:flex-row items-center justify-between w-[450px] lg:w-[290px] xl:w-[370px] 1xl:w-[400px] z-30 absolute left-[73px] xs:left-[88px] sm:left-[105px] md:-left-20 lg:left-10 xl:left-14 1xl:left-16 bottom-10 lg:bottom-12 1xl:bottom-14 gap-2 lg:gap-0 ${
          isVisible ? "animate-left-entry" : "opacity-0 scale-90"
        }`}
      >
        <div className=" flex items-center -space-x-3">
          {left.map((creator, index) => (
            <img
              key={index}
              src={creator}
              alt={`Creator ${index + 1}`}
              className="w-8 h-8 lg:w-10 lg:h-10 xl:w-12 xl:h-12 rounded-full border-2 border-[#161616] object-cover"
            />
          ))}
        </div>
        <h1 className="text-white text-xs md:text-lg lg:text-base xl:text-lg">
          Meet Our <span className="text-primary">Creators</span>
        </h1>
      </div>

      <div
        className={`flex flex-col lg:flex-row items-center justify-between w-[450px] lg:w-[290px] xl:w-[370px] 1xl:w-[400px] z-30 absolute right-[73px] xs:right-[88px] sm:right-[105px] md:-right-20 lg:right-10 xl:right-14 1xl:right-16 bottom-10 lg:bottom-12 1xl:bottom-14 gap-2 lg:gap-0 ${
          isVisible ? "animate-right-entry" : "opacity-0 scale-90"
        }`}
      >
        <h1 className="text-white text-xs md:text-lg order-2 lg:order-1">
          Who Trust Us
        </h1>
        <div className="flex items-center -space-x-3 order-1 lg:order-2">
          {right.map((creator, index) => (
            <img
              key={index}
              src={creator}
              alt={`Creator ${index + 1}`}
              className="w-8 h-8 lg:w-10 lg:h-10 xl:w-12 xl:h-12 rounded-full border-2 border-[#161616] object-cover"
            />
          ))}
        </div>
      </div>

      <img
        src={DarkRadial}
        className="absolute -bottom-[700px] left-1/2 -translate-x-1/2 z-40"
        alt="Dark Radial Background"
      />
    </div>
  );
}
